import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';

import styles from './ContentCard.styles';

const ContentCard = props => {
  const { content, onActionItemPress, images } = props;
  const theme = useTheme();
  const localImages = getThemeImages(theme.name);

  return (
    <View style={styles.container}>
      <VFText style={styles.title(theme)} i18nKey={content.title} />
      {!!content.description && (
        <VFText style={styles.description(theme)} i18nKey={content.description} />
      )}

      <TouchableOpacity
        onPress={() => onActionItemPress(content.actionKey)}
        style={styles.actionCard(theme)}
      >
        <Icon
          style={styles.leftIcon}
          name={images?.[content.actionIcon] ?? content.actionIcon}
          type="image"
          size={32}
        />

        <VFText style={styles.actionTitle(theme)} i18nKey={content.actionTitle} />

        <Icon name={localImages.ic_chevron_right} type="image" size={32} />
      </TouchableOpacity>
    </View>
  );
};

ContentCard.propTypes = {
  content: PropTypes.object.isRequired,
  onActionItemPress: PropTypes.func,
  images: PropTypes.object.isRequired,
};

export default ContentCard;
